var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"hide-details":"","append-icon":"search","label":_vm.$t('Person-Type'),"loading":_vm.loading,"items":_vm.items,"item-text":"Aciklama","cache-items":"","item-value":"Kod"},model:{value:(_vm.Kod),callback:function ($$v) {_vm.Kod=$$v},expression:"Kod"}})
}
var staticRenderFns = []

export { render, staticRenderFns }